import React, { useEffect, useState } from "react";
import { useTheme } from "../../../context/ThemeContext";
import { CustomDropdown } from "./CustomDropdown";
import { Plus, Trash } from 'lucide-react';
import headerDeleteIcon from "../../../images/Builder/delete_bordered.svg";
import headerDeleteDarkIcon from "../../../images/Builder/delete_bordered_dark.svg";


const ScreenerModal = ({ parentCallback, screeningSuccess, isModalOpen, setIsModalOpen }) => {

  const { theme } = useTheme();
  const [isRowEnabled, setIsRowEnabled] = useState(true);
  const INITIAL_ROWS = [
    {
      isEnabled: true,
      hasTick: true,
      data: {
        isBuy: true,
        isCALL: true,
        selectedExpiry: "Current Week",
        lotsValue: 1,
        selectedCondition: "delta",
        inputValue: 15,
      },
    },
    {
      isEnabled: false,
      hasTick: false,
      data: {
        isBuy: true,
        isCALL: true,
        selectedExpiry: "Current Week",
        lotsValue: 1,
        selectedCondition: "delta",
        inputValue: 15,
      },
    },
  ];
  const [rows, setRows] = useState([...INITIAL_ROWS]);
  const closeModal = () => {
    const modalCloseButton = document.querySelector(
      '[data-bs-dismiss="modal"]'
    );
    if (modalCloseButton) {
      modalCloseButton.click();
    }
  };

  const handleOptionItemClick = (index, item) => {
    const updatedRows = [...rows];
    updatedRows[index].data.selectedCondition = item;
    setRows(updatedRows);
  };

  useEffect(() => {
    setIsRowEnabled(true);
  }, []);

  const toggleRow = (index) => {
    const updatedRows = [...rows];
    updatedRows[index].isEnabled = !updatedRows[index].isEnabled;
    setRows(updatedRows);
  };

  const toggleIcon = (index) => {
    const updatedRows = [...rows];

    if (updatedRows[index].hasTick) {
      updatedRows.splice(index, 1);
    } else {
      updatedRows[index].hasTick = true;
      updatedRows[index].isEnabled = true;
      updatedRows.splice(index + 1, 0, {
        isEnabled: false,
        hasTick: false,
        data: {
          isBuy: true,
          isCALL: true,
          selectedExpiry: "Current Week",
          lotsValue: 1,
          selectedCondition: "delta",
          inputValue: 15,
        },
      });
    }
    setRows(updatedRows);
  };

  const updateIsBuy = (index) => {
    const updatedRows = [...rows];
    updatedRows[index].data.isBuy = !updatedRows[index].data.isBuy;
    setRows(updatedRows);
  };

  const updateIsCALL = (index) => {
    const updatedRows = [...rows];
    updatedRows[index].data.isCALL = !updatedRows[index].data.isCALL;
    setRows(updatedRows);
  };

  const updateLotsValue = (index, value) => {
    const updatedRows = [...rows];
    updatedRows[index].data.lotsValue = value;
    setRows(updatedRows);
  };

  const updateInputValue = (index, value) => {
    const updatedRows = [...rows];
    updatedRows[index].data.inputValue = value;
    setRows(updatedRows);
  };

  const generateArray = () => {
    const newArray = rows.map((row) => row);
    parentCallback(newArray);
    setRows([...INITIAL_ROWS]);
    setIsModalOpen(false)
  };

  return (
    <>
      <dialog
        id="staticBackdropScreener"
        className={`modal ${isModalOpen ? "modal-open" : ""}`}>
        <div className="modal-box w-auto bg-modalBg rounded-md no-scrollbar p-0">
          <div className="flex items-center justify-between px-3 py-4 border-b border-n200">
            <p className=" font-semibold text-p300">Auto find</p>
            {/* <form method="dialog"> */}
              <button
                onClick={() => {
                  setIsModalOpen(false);
                  setRows([...INITIAL_ROWS]);
                }}
                className="btn btn-xs btn-circle hover:text-p400 bg-p400 border-n200 text-p300">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            {/* </form> */}
          </div>

          <div className=" ">
            <table className="w-full">
              <thead>
                <tr className="flex items-center justify-start gap-5 text-left text-n500 text-[10px] px-4 py-2.5 border-b border-n200 mb-2">
                  <th scope="col" className="font-medium">
                    B/S
                  </th>
                  <th scope="col" className="font-medium">
                    <span>Type</span>
                  </th>
                  <th scope="col" className="font-medium">
                    Lots
                  </th>
                </tr>
              </thead>
              <div className="max-h-[110px] min-h-[110px] overflow-y-auto no-scrollbar ">
                <tbody>
                  {rows.map((row, index) => (
                    <tr
                      key={index}
                      className={`flex items-center gap-4 text-center px-2 pb-1 ${
                        row.isEnabled ? "" : "opacity-50"
                      }`}>
                      <td>
                        <div
                          className={`w-[26px] h-[26px] flex items-center justify-center rounded text-white text-[10px] font-bold cursor-pointer ${row.data.isBuy ? "bg-p150" : "bg-red"}`}
                          onClick={() => updateIsBuy(index)}>
                          {row.data.isBuy ? "B" : "S"}
                        </div>
                      </td>

                      <td>
                        <div
                          className={`flex items-center justify-center w-[26px] h-[26px] rounded border-[1.5px] text-[10px] text-p300 font-medium cursor-pointer ${row.data.isCALL ? " border-p150" : " border-red"}`}
                          onClick={() => updateIsCALL(index)}>
                          {row.data.isCALL ? "CE" : "PE"}
                        </div>
                      </td>

                      <td>
                        <div className="flex items-center justify-between w-20 relative">
                          <CustomDropdown
                            options={[...Array(50)].map((_, i) => i + 1)}
                            value={row.data.lotsValue}
                            onChange={(val) => updateLotsValue(index, val)}
                            isLots={true}
                          />
                        </div>
                      </td>

                      <td>
                        <div className=" relative">
                          <CustomDropdown
                            options={["Delta", "Theta", "Gamma", "Vega"]}
                            value={row.data.selectedCondition}
                            onChange={(val) =>
                              handleOptionItemClick(index, val.toLowerCase())
                            }
                            isLots={true}
                            isGreeks={true}
                          />
                        </div>
                      </td>

                      <td className={`${row.isEnabled ? "" : "text-gray-400"}`}>
                        <input
                          type="number"
                          value={row.data.inputValue}
                          className=" w-12 rounded-sm bg-p400 text-p300 text-[12px] font-medium border border-n200 px-2 py-0.5"
                          onChange={(e) =>
                            updateInputValue(index, e.target.value)
                          }
                        />
                      </td>

                      <td>
                        <span className="cursor-pointer">
                          {row.hasTick ? (
                            <img
                              onClick={() => toggleIcon(index)}
                              src={
                                theme === "dark"
                                  ? headerDeleteDarkIcon
                                  : headerDeleteIcon
                              }
                              alt="delete"
                              width={20}
                              height={20}
                            />
                          ) : (
                            <div
                              className="cursor-pointer p-1 border border-p300 rounded bg-p400 shadow-sm opacity-100"
                              onClick={() => toggleIcon(index)}>
                              <Plus className="w-3 h-3 text-p300" />
                            </div>
                          )}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </div>
            </table>
          </div>

          <div className="modal-action">
            <button
              className="bg-swipe-button text-p400 text-[12px] font-semibold rounded-[4px] px-4 py-1 mr-2 mb-4"
              onClick={generateArray}>
              Screen
            </button>
          </div>
        </div>
      </dialog>
    </>
  );
};

export default ScreenerModal;
